module.exports = __webpack_public_path__ + "img/C2.aa543d65.webp";